import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { WalkingNode } from '../../types';
import { getWalkingLabel, normalizeWalkingData } from '../../config/walkingMotions';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { getWalkingDirection, getWalkingStepsLabel } from '../../animation/walkingMotion';
import { CardShell } from '../CardShell';

const ENGLISH_SUMMARY: Record<string, (count: number) => string> = {
  4: count => `Forward ${count} steps`,
  5: count => `Backward ${count} steps`,
  1002: count => `Move left ${count} times`,
  1006: count => `Move right ${count} times`,
  1009: count => `Curve right ${count} steps`,
  1010: count => `Curve left ${count} steps`,
};

export const WalkingNodeView = memo(function WalkingNodeView({ data: rawData }: NodeProps<WalkingNode>) {
  const displayLanguage = useFlowDisplayLanguage();
  const data = normalizeWalkingData(rawData);
  const direction = getWalkingDirection(Number(data.motionId));

  return (
    <CardShell
      kind="walking"
      accent="teal"
      title={getNodeDisplayLabel('walking', displayLanguage)}
      summary={data.stepCount === undefined || !direction
        ? getWalkingLabel(data.motionId) ?? ''
        : displayLanguage === 'en'
          ? ENGLISH_SUMMARY[data.motionId!](data.stepCount)
          : getWalkingStepsLabel(direction, data.stepCount)}
    >
      <Handle type="target" position={Position.Left} className="!bg-teal-500" />
      <Handle type="source" position={Position.Right} className="!bg-teal-500" />
    </CardShell>
  );
});